import { render, staticRenderFns } from "./TopicOriginManagement.vue?vue&type=template&id=05e0ab62&scoped=true"
import script from "./TopicOriginManagement.vue?vue&type=script&lang=js"
export * from "./TopicOriginManagement.vue?vue&type=script&lang=js"
import style0 from "./TopicOriginManagement.vue?vue&type=style&index=0&id=05e0ab62&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05e0ab62",
  null
  
)

export default component.exports